import { render, staticRenderFns } from "./selectEventAdd.vue?vue&type=template&id=1a61eb70&"
import script from "./selectEventAdd.vue?vue&type=script&lang=ts&"
export * from "./selectEventAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports